import { useEffect, useState } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { SiMicrosoftexcel } from "react-icons/si";

function BasicExample() {
  const [tipoCliData, setTipoCliData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const tipoCli = res.data?.TP?.tipo_cli || [];
        const lastMinuti = res.data?.TP?.lastminuti || [];

        const today = new Date().toISOString().split("T")[0];

        // 1️⃣ Somma Last Minute per tipo_cliente
        const lastMinutiMap = lastMinuti.reduce((acc, item) => {
          if (item.data_ordine?.startsWith(today)) {
            const tipo = item.tipo_cliente;
            const valore = parseFloat(item.ordinato.replace(",", "."));
            acc[tipo] = (acc[tipo] || 0) + valore;
          }
          return acc;
        }, {});

        // 2️⃣ Trasforma i dati e calcola Last Minute e Regular
        const transformedData = tipoCli.map(item => {
          const totale = parseFloat(item.valore.replace(",", "."));
          const lastMinute = lastMinutiMap[item.tipo_cliente] || 0;
          const regular = Math.max(totale - lastMinute, 0);
          return {
            tipo_cliente: item.tipo_cliente,
            totale: totale,
            lastMinute: lastMinute,
            regular: regular,
            numero: parseInt(item.numero),
            origine: item.origine
          };
        });

        // 3️⃣ Ordina decrescente per totale
        const sortedData = transformedData.sort((a, b) => b.totale - a.totale);

        setTipoCliData(sortedData);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  const formatToEuro = (amount) => 
    new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(amount || 0);

  const exportToExcel = () => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileName = "tipo_cli.xlsx";
    const data = tipoCliData.map(item => ({
      Tipo_Cliente: item.tipo_cliente,
      Totale: item.totale,
      LastMinute: item.lastMinute,
      Regular: item.regular,
      Numero: item.numero
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelData, fileName);
  };

  return (
    <div className='widget-client2 ombra tb hover-effect' style={{borderRadius: '10px', backgroundColor: "hsl(0, 0%, 89%)", border: '1px solid rgb(200, 200, 200)'}}>
      <Table variant='secondary' style={{ fontSize: '0.8rem'}}>
        <thead>
          <tr>
            <th className='bg-dark text-light sticky-top'>Tipo Cliente</th>
            <th className='bg-dark text-light sticky-top'>Valore</th>
            <th className='bg-dark text-light sticky-top'>Last Minute</th>
            <th className='bg-dark text-light sticky-top'>Regular</th>
            <th className='bg-dark text-light sticky-top'>Numero</th>
            <th className="bg-success text-light sticky-top text-center excel" onClick={exportToExcel} style={{width: '6%'}}>
              <SiMicrosoftexcel className="fs-5"/>
            </th>
          </tr>
        </thead>
        <tbody>
          {tipoCliData.map((item, index) => (
            <tr key={index}>
              <td>{item.tipo_cliente}</td>
              <td className='fw-bold'>{formatToEuro(item.totale)}</td>
              <td>{formatToEuro(item.lastMinute)}</td>
              <td>{formatToEuro(item.regular)}</td>
              <td>{item.numero}</td>
              <td></td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default BasicExample;
